export default __webpack_public_path__ + "static/SRF 4270LV - Fiche de spécifications et données techniques-d344dc8deb16dedf63f41a1c99cf4556.pdf";